/* src/app/modules/subscription/booking-subscription-activation-dialog/booking-subscription-activation-dialog.component.css */
.booking-activation-dialog {
  padding: 0;
}
.dialog-header {
  background:
    linear-gradient(
      135deg,
      #d48f00 0%,
      #b8790a 100%);
  color: white;
  padding: 24px 24px 20px;
  text-align: left;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0 8px 24px rgba(212, 143, 0, 0.28);
}
.dialog-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.dialog-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  opacity: 0.9;
}
.dialog-body {
  padding: 24px;
  max-height: calc(80vh - 100px);
  overflow-y: auto;
}
.trial-info-box {
  background: #f8ffe0;
  border-left: 4px solid #c9e64a;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 24px;
}
.trial-highlight {
  display: flex;
  align-items: center;
  gap: 16px;
}
.trial-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: var(--cf-brand-dark, #d48f00);
}
.trial-text h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.trial-period {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: var(--cf-brand-dark, #d48f00);
  font-weight: 500;
}
.pricing-info {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 24px;
}
.pricing-label {
  font-size: 12px;
  color: #999;
  text-transform: uppercase;
  margin-bottom: 12px;
  font-weight: 600;
}
.pricing-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #eee;
}
.pricing-period {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
.pricing-amount {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.pricing-unit {
  font-size: 12px;
  font-weight: 400;
  color: #999;
}
.benefits-section {
  margin-bottom: 24px;
}
.benefits-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.benefits-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.benefits-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  color: #666;
}
.benefits-list mat-icon {
  color: #4caf50;
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.conditions-note {
  background: #f8ffe0;
  border-left: 4px solid #c9e64a;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 24px;
}
.conditions-note p {
  margin: 0;
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #eee;
  background: #fafafa;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.btn-cancel {
  color: #666;
  font-weight: 500;
}
.btn-confirm {
  min-width: 150px;
  font-weight: 600;
  color: #1f1f1f !important;
  background:
    linear-gradient(
      135deg,
      #e3fd64 0%,
      #c9e64a 100%) !important;
  box-shadow: 0 6px 16px rgba(201, 230, 74, 0.35) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.btn-confirm:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(201, 230, 74, 0.45) !important;
}
@media (max-width: 600px) {
  .dialog-header {
    padding: 20px 16px 16px;
  }
  .dialog-body {
    padding: 16px;
  }
  .dialog-actions {
    padding: 12px 16px;
    flex-direction: column-reverse;
  }
  .btn-confirm {
    min-width: auto;
    width: 100%;
  }
  .btn-cancel {
    width: 100%;
  }
}
/*# sourceMappingURL=booking-subscription-activation-dialog.component.css.map */
